import type { SuperHubRouteParams } from './types';
import type useReadmeApi from '@core/hooks/useReadmeApi';

import { superHubSidebarTypes } from '@core/store';

interface IsSidebarLoadedForSectionParams {
  isLoading: boolean;
  section: SuperHubRouteParams['section'];
  sidebarKey: ReturnType<typeof useReadmeApi>['swrKey'];
}

/**
 * Determines whether the SuperHub sidebar data for the given section has been
 * loaded for the current request key.
 *
 * We use the SWR key (which contains the request URL) to validate that the
 * loaded sidebar corresponds to the current section before we proceed with any
 * "first page" redirects.
 */
export function isSidebarLoadedForSection({ section, sidebarKey, isLoading }: IsSidebarLoadedForSectionParams) {
  if (!section) return true;

  const pageType = superHubSidebarTypes[section];
  if (!pageType) return true;

  const sidebarUrl = typeof sidebarKey === 'string' ? sidebarKey : sidebarKey?.[0] || '';
  const queryString = sidebarUrl.split('?')[1];
  const sidebarUrlParams = new URLSearchParams(queryString);

  return sidebarUrlParams.get('page_type') === pageType && !isLoading;
}
